import styled, { css, keyframes } from "styled-components";
import { FlexBox } from "../../styles/global";

interface CardInfoInterface {
  color?: string;
}

interface StyledComponentProps {
  hospital: string;
}

const getHospitalColor = (item: StyledComponentProps["hospital"]): string => {
  switch (item) {
    case "HRBz":
    case "HRC":
    case "HRSam":
    case "HSVP":
    case "HRT":
      return "#527d9b";
    case "HRPL":
    case "HRS":
    case "HRL":
      return "#af6c9c";
    case "HRGu":
    case "HRG":
    case "HMIB":
    case "HRAN":
    default:
      return "#ED94AA";
  }
};

function getHospitalColorSolid(hospital: string): string {
  // Pega a cor base dinâmica (ex: "#4079BC")
  const hex: string = getHospitalColor(hospital);

  if (!/^#[0-9A-Fa-f]{6}$/.test(hex)) {
    throw new Error(`Cor inválida: ${hex}`);
  }

  // Converte hex para RGB
  const r: number = parseInt(hex.slice(1, 3), 16);
  const g: number = parseInt(hex.slice(3, 5), 16);
  const b: number = parseInt(hex.slice(5, 7), 16);

  const alpha: number = 176 / 255; // B0 em decimal

  const blend = (channel: number): number =>
    Math.round(alpha * channel + (1 - alpha) * 255);

  const rNew: number = blend(r);
  const gNew: number = blend(g);
  const bNew: number = blend(b);

  // Retorna cor sólida em hex
  return `#${rNew.toString(16).padStart(2, "0")}${gNew
    .toString(16)
    .padStart(2, "0")}${bNew.toString(16).padStart(2, "0")}`;
}

const blink = keyframes`
  50% {
    opacity: 0;
  }
`;

export const ContainerHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 2rem;
  h3 {
    margin: 0;
  }
`;

export const ContainerCard = styled.div`
  border: 1px solid #cecece;
  height: 300px;
  width: 300px;
  background-color: #fff;
  border-radius: 8px;
`;

export const Full = styled.div`
  height: 80%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  position: relative;

  h3 {
    color: ${(props) => props.theme.colors.black};
    margin: -5px 0 5px 0 !important;
  }

  div:nth-child(2) {
    position: absolute;
    right: 0;
    top: -6px;
  }

  svg {
    font-size: 1.5rem;
    color: red;
  }

  @media (max-width: 700px) {
    div:nth-child(2) {
      top: -7px;
    }
  }
`;

export const CardHeaderClean = styled.div<StyledComponentProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  position: relative;
  background-color: ${(props) => getHospitalColor(props.hospital)}B0;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  h3 {
    color: white;
    line-height: 40px;
  }
`;

export const CardContainer = styled.div`
  width: 100%;
  padding-top: 16px;
  h3 {
    margin: 0;
    padding: 0;
  }

  @media (max-width: 844px) {
    order: 2;
  }
`;

export const HospitalChip = styled.div<StyledComponentProps>`
  // margin: 1rem;
  // border: solid 2px ${(props) => getHospitalColor(props.hospital)}B0;
  // border-radius: 10px;
`;

const commonCardStyles = css<StyledComponentProps>`
  background: #fff;
  // border: 4px solid ${(props) => getHospitalColor(props.hospital)}B0;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const Card = styled.div<StyledComponentProps>`
  ${commonCardStyles}
  display: inline-block;
  float: left;
  width: calc(33% - 16px);
  margin: 0 0 16px 16px;
  padding: 13px;

  @media (max-width: 1440px) {
    width: calc(50% - 24px);
  }

  @media (max-width: 768px) {
    width: calc(100% - 32px);
  }
`;

export const OrderedFlexBox = styled(FlexBox)`
  @media (max-width: 844px) {
    order: 1;
  }
`;

export const BigCard = styled.div<StyledComponentProps>`
  ${commonCardStyles}
`;

export const ChipsCard = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  border-radius: 8px;
  background-color: #d9d9d9;
  min-height: auto;
  width: 100%;
  padding: 10px;
  gap: 3px;

  p {
    margin: 0;
    padding: 0;
  }

  span {
    font-weight: bold;
    font-size: 16px;
  }
`;

export const ChipsCardClean = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  p {
    font-size: 18px;
    white-space: nowrap;
  }

  span {
    font-weight: bold;
    font-size: 30px;
  }

  p.small {
    font-size: 14px;
    white-space: wrap;
  }

  span.smallNum {
    font-size: 18px;
  }

  span.smallNum2 {
    font-size: 14px;
  }

  span.smallNum3 {
    font-size: 12px;
  }
`;

export const ChipsCardEspecialidade = styled.div`
  // border-bottom: solid 3px ${(props) => props.color};
  // border-right: solid 3px ${(props) => props.color};

  // border: solid 1px ${(props) => props.color};
  border: solid 1px #8791c3;
  border-radius: 10px;

  padding: 0.5rem 1rem 0;

  h3 {
    font-size: 16px;
  }

  p,
  span.num {
    font-size: 14px;
  }

  .espera {
    p {
      font-size: 16px;
    }
    span.num {
      font-size: 18px;
    }
  }
`;

export const DivInfoMedia = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-size: 9px;
  }
`;

export const CardInfo = styled.div<CardInfoInterface & { border?: boolean }>`
  border: ${(props) =>
    props.border === false
      ? "none"
      : `3px solid ${props.color ? props.color : "#3366FF"}`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  border-radius: 10px;
  gap: 10px;

  svg {
    /* color: #fff; */
    color: ${(props) => (props.color ? props.color : "#3366FF")};
    /* font-size: 30px; */
  }

  span {
    font-weight: bold;
    font-size: 14px;
    color: ${(props) => props.theme.colors.black};
  }

  div:nth-child(2) {
    span {
      font-size: 14px;
    }
  }
`;

export const PLineHeigth2 = styled.div`
  line-height: 1;
  font-weight: 400;
  color: #8b8000;
  font-size: 12px;
`;

export const PLineHeigth3 = styled.div<{ tipo?: "agora" | "24h" | "7d" }>`
  // background-color: #8b8000;
  background-color: #b1b9dc;
  color: white;
  width: fit-content;
  padding: 3px 10px;
  border-radius: 10px;
  font-size: 14px;
  // text-shadow: 1px 1px 10px white;
  white-space: nowrap;
  margin: 0 auto;
  z-index: 100;
  position: relative;
  top: 11px;
  // background-color: #b2b9e0;
  // border: 1px solid #5f6799;
`;

export const PLineHeigth4 = styled.div<
  StyledComponentProps & { tipo?: "agora" | "24h" | "7d" }
>`
  background-color: ${(props) => getHospitalColorSolid(props.hospital)};
  // background-color: #cfc87a;
  color: white;
  width: fit-content;
  padding: 3px 10px;
  border-radius: 10px;
  font-size: 14px;
  white-space: nowrap;
  margin: 0 auto;
  z-index: 100;
  position: relative;
  top: 11px;
`;

export const BlinkText = styled.p`
  animation: ${blink} 1s step-start infinite;
`;

export const InfoBox = styled.div`
  background-color: #e9e9e9;
  // border: 1px solid #bbb;
  border-radius: 10px;
  padding: 1rem 0.5rem 0.5rem;
`;

export const Show7d = styled.p`
  position: absolute;
  top: 1rem;
  right: 1rem;
  height: 20px;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: blue;
  }
`;

export const IconBox = styled.p<StyledComponentProps>`
  // color: ${(props) => getHospitalColorSolid(props.hospital)};
  color: #c8a2c8;
`;
